// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"207":"a8e8f031","455":"63abe532","689":"a3b89959","977":"905d87b2"}[chunkId] + ".chunk.js";
};